export default __webpack_public_path__ + "static/important-renovation-0ba8c9874c47e3e786dd690487f8754e.jpg";